<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="next"><img alt="" class="_idGenObjectAttribute-1" src="image/1.png"/></p>
<p class="Book-Title_SubHeading">Essential Elixirs</p>
<p class="Book-Title_SubHeading">for the Mind, Body, </p>
<p class="Book-Title_SubHeading">and Spirit</p>
<p class="Book-Title_SubHeading"> </p>
<p class="Book-Title_SubHeading"> </p>
<p class="Book-Title_Author">Elise Marie Collins</p>
<p class="pictures_Conari-Logo"><img alt="" class="_idGenObjectAttribute-2" src="image/cplogo_titlepage.png"/></p>
<p class="Book-Title_Coral-Gables _idGenParaOverride-1">Coral <span class="noBreak">Gables, FL</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ChakraTonicsebk1.vue?3d6a2ee4